import { render, staticRenderFns } from "./videoMarkingDialog.vue?vue&type=template&id=6a4f9f0d&scoped=true&"
import script from "./videoMarkingDialog.vue?vue&type=script&lang=js&"
export * from "./videoMarkingDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoMarkingDialog.vue?vue&type=style&index=0&id=6a4f9f0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f9f0d",
  null
  
)

export default component.exports